import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { DashboardServices } from "../../redux/Services";
import { UserId, RoleId, GetLoggedInUser } from "../../utils";

import Boxes from "../Boxes/Boxes";

import { usePermission } from "../../hooks/usePermission";
const Abdm = () => {
  const permission = usePermission("HIP Dashboard", "List");
  if (!permission) {
    const UserData = GetLoggedInUser();
    const Permission = UserData?.permission
      ? JSON.parse(UserData?.permission)
      : null;
    if (Permission) {
      if (Permission[0]["module"] == "HIU Dashboard") {
        window.location.pathname = "/hiu-dashboard";
      }
    } else {
      console.log("Empty permission");
    }
  }
  const dispatch = useDispatch();
  const user = {
    UserId: UserId,
    RoleId: RoleId
  };
  const dashboardCounts = useSelector(
    (state) => state.dashboard.dashboardCounts || {}
  );
  const { mutate: getDashboardCount } = useMutation((data) =>
    dispatch(DashboardServices.getDashboardCount(data, user))
  );
  // const { mutate: getRcordLinked } = useMutation((data) => dispatch(DashboardServices.getDashboardLinkedCount(data, user)));
  useEffect(() => {
    getDashboardCount({});
    // getRcordLinked({});
  }, []);
  return (
    <div>
      <Row gutter={[20, 20]} type="flex">
        <Col lg={24} md={24} sm={24} xs={24}>
          <div>
            <Boxes />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Abdm;
